import React from 'react';
import LegalPage from '../components/LegalPage';

const CookiePolicy: React.FC = () => {
  const cookiePolicyContent = (
    <>
      <p>
        This Cookie Policy explains how Translate Stocks ("we", "us", or "our") uses cookies and similar technologies to recognize, collect and store information when you visit our website or use our services.
      </p>
      
      <h2>What are cookies?</h2>
      <p>
        Cookies are small text files that are stored on your device (computer, tablet, or mobile) when you visit a website. Cookies are widely used to make websites work more efficiently and provide information to the owners of the site.
      </p>
      <p>
        Cookies can be "persistent" or "session" cookies. Persistent cookies remain on your device when you go offline, while session cookies are deleted as soon as you close your web browser.
      </p>
      
      <h2>How we use cookies</h2>
      <p>
        We use cookies for the following purposes:
      </p>
      
      <h3>Necessary cookies</h3>
      <p>
        These cookies are essential for you to browse our website and use its features. The information collected by these cookies relate to the operation of our website, for instance website authentication, user sessions, and security measures. These cookies cannot be disabled.
      </p>
      
      <h3>Analytics cookies</h3>
      <p>
        These cookies allow us to count visits and traffic sources so we can measure and improve the performance of our site. They help us to know which pages are the most and least popular and see how visitors move around the site. All information these cookies collect is aggregated and anonymous.
      </p>
      
      <h3>Marketing cookies</h3>
      <p>
        These cookies may be set through our site by our advertising partners. They may be used by those companies to build a profile of your interests and show you relevant adverts on other sites. They do not store directly personal information but are based on uniquely identifying your browser and internet device.
      </p>
      
      <h3>Preference cookies</h3>
      <p>
        These cookies enable our website to remember choices you make (such as your preferred language or the region you are in) and provide enhanced, more personal features. These cookies can also be used to remember changes you have made to text size, fonts and other parts of web pages that you can customize.
      </p>
      
      <h2>Cookies we use</h2>
      <p>
        Below is a detailed list of the cookies we use on our website:
      </p>
      
      <h3>Necessary cookies</h3>
      <ul>
        <li><strong>cookieConsent</strong> - Stores your cookie consent preferences</li>
        <li><strong>cookiePreferences</strong> - Stores which types of cookies you've agreed to</li>
        <li><strong>session</strong> - Maintains your session state while you're browsing our website</li>
        <li><strong>XSRF-TOKEN</strong> - Helps protect against Cross-Site Request Forgery attacks</li>
      </ul>
      
      <h3>Analytics cookies</h3>
      <ul>
        <li><strong>_ga, _gid, _gat</strong> - Google Analytics cookies used to distinguish users and throttle request rate</li>
        <li><strong>_hjid, _hjIncludedInSample</strong> - Hotjar cookies used to identify a user's session and to determine if they are included in sample data</li>
      </ul>
      
      <h3>Marketing cookies</h3>
      <ul>
        <li><strong>_fbp, fr</strong> - Facebook Pixel cookies used for advertising purposes</li>
        <li><strong>ads/ga-audiences</strong> - Google Ads cookie used for remarketing</li>
        <li><strong>IDE, DSID</strong> - Google DoubleClick cookies for advertising</li>
      </ul>
      
      <h3>Preference cookies</h3>
      <ul>
        <li><strong>ui_preferences</strong> - Stores your UI preferences such as theme choice</li>
        <li><strong>language</strong> - Remembers your preferred language</li>
        <li><strong>recently_viewed</strong> - Tracks which products or services you've recently viewed</li>
      </ul>
      
      <h2>How to manage cookies</h2>
      <p>
        You can set your browser to refuse all or some browser cookies, or to alert you when websites set or access cookies. If you disable or refuse cookies, please note that some parts of this website may become inaccessible or not function properly.
      </p>
      <p>
        You can also manage your cookie preferences at any time by clicking on the "Cookie Preferences" link in the footer of our website.
      </p>
      
      <h3>Browser settings</h3>
      <p>
        Most web browsers allow control of cookies through the browser settings. To find out more about cookies, including how to see what cookies have been set and how to manage and delete them, visit <a href="https://www.aboutcookies.org" target="_blank" rel="noopener noreferrer">www.aboutcookies.org</a> or <a href="https://www.allaboutcookies.org" target="_blank" rel="noopener noreferrer">www.allaboutcookies.org</a>.
      </p>
      
      <h3>Third-party cookies</h3>
      <p>
        Please note that third parties (including, for example, advertising networks and providers of external services like web traffic analysis services) may also use cookies, over which we have no control. These cookies are likely to be analytical/performance cookies or targeting cookies.
      </p>
      
      <h2>Changes to this Cookie Policy</h2>
      <p>
        We may update this Cookie Policy from time to time in order to reflect changes to the cookies we use or for other operational, legal or regulatory reasons. Please therefore re-visit this Cookie Policy regularly to stay informed about our use of cookies and related technologies.
      </p>
      <p>
        The date at the top of this Cookie Policy indicates when it was last updated.
      </p>
      
      <h2>Contact us</h2>
      <p>
        If you have any questions about our use of cookies or other technologies, please email us at trader@translatestocks.com.
      </p>
    </>
  );
  
  return (
    <LegalPage
      title="Cookie Policy"
      lastUpdated="March 01, 2021"
      content={cookiePolicyContent}
    />
  );
};

export default CookiePolicy;